import { testimonials } from "@/mocks/comics";
import SectionHeader from "@/components/feature/SectionHeader";

function Testimonials() {
  return (
    <section className="border-t border-background-800 bg-background-900/40 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeader
          eyebrow="Member Voices"
          title="尊贵会员口碑"
          desc="来自尊享会员与钻石会员的真实阅读感受，是对土豪漫画网尊贵体验的最好证明。"
          align="center"
        />

        <div className="mt-12 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-4">
          {testimonials.map((t) => (
            <figure
              key={t.name}
              className="flex flex-col rounded-lg border border-background-800 bg-background-950 p-6 transition hover:border-primary-500/40"
            >
              <div className="flex items-center gap-1 text-primary-400">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-sm"></i>
                ))}
              </div>
              <blockquote className="mt-4 flex-1 text-sm leading-7 text-foreground-300">
                “{t.content}”
              </blockquote>
              <figcaption className="mt-5 flex items-center gap-3 border-t border-background-800 pt-4">
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-gradient-to-br from-primary-500 to-accent-500 font-heading text-sm font-bold text-foreground-950">
                  {t.name.slice(0, 1)}
                </span>
                <div>
                  <p className="text-sm font-semibold text-foreground-100">{t.name}</p>
                  <p className="text-xs text-primary-400">{t.level} · {t.title.split("·")[1]}</p>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Testimonials;